import { Lock, AlertCircle, CheckCircle2 } from "lucide-react";

/** Cornice condivisa dalle pagine di accesso, recupero e reset password. */
export default function AdminAuthShell({ title, intro, error, success, children, footer, testId }) {
  return (
    <main
      data-testid={testId}
      className="min-h-screen bg-slate-900 flex items-center justify-center px-4 py-12"
    >
      <div className="w-full max-w-md bg-white p-10 border border-slate-200 shadow-2xl">
        <div className="w-12 h-12 rounded-full bg-slate-900 flex items-center justify-center mb-6">
          <Lock size={18} className="text-amber-300" />
        </div>
        <div className="overline">Area riservata</div>
        <h1 className="font-serif text-3xl mt-3 text-slate-900">{title}</h1>
        {intro && <p className="mt-2 text-sm text-slate-500">{intro}</p>}

        {error && (
          <div
            data-testid="admin-auth-error"
            className="mt-6 flex items-start gap-3 p-3 bg-red-50 border border-red-200 text-red-800 text-sm"
          >
            <AlertCircle size={16} className="mt-0.5 shrink-0" />
            <span>{error}</span>
          </div>
        )}

        {success && (
          <div
            data-testid="admin-auth-success"
            className="mt-6 flex items-start gap-3 p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 text-sm"
          >
            <CheckCircle2 size={16} className="mt-0.5 shrink-0" />
            <span>{success}</span>
          </div>
        )}

        {children}

        {footer && <div className="mt-6 text-sm text-slate-500">{footer}</div>}
      </div>
    </main>
  );
}

/** Input di testo con etichetta, nello stile del pannello. */
export function AuthField({ label, hint, ...props }) {
  return (
    <div>
      <label className="block text-xs font-medium uppercase tracking-wider text-slate-700 mb-2">
        {label}
      </label>
      <input
        {...props}
        className="w-full border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:border-slate-900 transition-colors"
      />
      {hint && <p className="mt-2 text-xs text-slate-500">{hint}</p>}
    </div>
  );
}

/** Pulsante primario a piena larghezza. */
export function AuthSubmit({ loading, loadingLabel, children, ...props }) {
  return (
    <button
      type="submit"
      disabled={loading}
      {...props}
      className="w-full bg-slate-900 hover:bg-amber-800 disabled:opacity-50 text-white py-3 rounded-full font-medium transition-colors"
    >
      {loading ? loadingLabel : children}
    </button>
  );
}
